import { render, staticRenderFns } from "./safetyGearPop.vue?vue&type=template&id=b801a552"
import script from "./safetyGearPop.vue?vue&type=script&lang=js"
export * from "./safetyGearPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b801a552')) {
      api.createRecord('b801a552', component.options)
    } else {
      api.reload('b801a552', component.options)
    }
    module.hot.accept("./safetyGearPop.vue?vue&type=template&id=b801a552", function () {
      api.rerender('b801a552', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/sas/safetyGearPop.vue"
export default component.exports